export function capitalizeFirstChar(str: string): string {
  if (!str || str.length === 0) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const diacriticMarkRegex = /[\u0300-\u036f]/g;

export function latinize(str: string, replaceDiactricMarks = true): string {
  if (replaceDiactricMarks) {
    return str.normalize('NFD').replace(diacriticMarkRegex, '');
  }

  return str.normalize('NFD');
}
